module.exports = __webpack_public_path__ + "img/galeria_salas_de_aula (2).3d490469.jpeg";